// extracted by mini-css-extract-plugin
export default {"container":"GBvrGQpKFe2pLVc5cixg"};